<template>
	<MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                :allow_hour_list="allow_hour_list"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-if="unit_column_list.length > 1" #description>
            <v-btn 
                class="switch-btn"
                @click="switch_unit_column"
            >
                切換表格單位
            </v-btn>
        </template>

        <template v-slot:data_table="slot_props">
            <QpeDatatable
                class="datetime_merge_monitor"
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :should_show_raw_html_header="should_show_raw_html_header"
                :custom_header="true"
                :show_table_border="true"
                :show_download_pdf_btn="false"
                :show_download_png_btn="false"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template v-slot:table_description>
                    <span>
                        說明：<br>
                        --: 無資料
                    </span>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
import * as dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)
import { redirect_monitor_table_ajax } from '@/utils/monitor/monitor.js'
import { monitor_mixin } from '@/utils/monitor/monitor_mixin.js'
import { alert_color_style_mapping } from '@/config/monitor_config.js'
import cloneDeep from 'lodash/cloneDeep'
import { TABLE_VALUE_TEXT_MAPPING } from '@/config/monitor_config.js'
import MonitorLayoutTemplate from '@/components/monitor/_tool/layout_template.vue'
import QpeDatetime from '@/components/monitor/qpe_datetime.vue'
import QpeDatatable from '../qpe_datatable.vue'

export default {
    name: 'datetime_merge',

    components: {
        MonitorLayoutTemplate,
        QpeDatetime,
        QpeDatatable,
    },

    props: {
        default_value: {
            type: Number,
            required: true,
        },
    },

    mixins: [monitor_mixin],

    data() {
        return {
            header: [],
            immutable_table_data: [],
            immutable_table_header: [],
            table_data: [],
            error_text: '',
            allow_hour_list: [2, 5, 8, 11, 14, 17, 20, 23],
            allow_hour_list: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
            should_show_raw_html_header: [],
            selected_unit: '',
        }
    },

    computed: {
        table_title() {
            return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
        },
        colspan_column() {
            return TABLE_VALUE_TEXT_MAPPING[this.default_value]['colspan_column']
        },
        unit_column_list() {
            return TABLE_VALUE_TEXT_MAPPING[this.default_value]['column']
        },
    },

    created() {
        redirect_monitor_table_ajax.call(this, this.default_value)

        this.unit_column = this.unit_column_list[0]
    },

    methods: {
        generate_table_data(data, header) {
            this.immutable_table_data = data
            this.immutable_table_header = header
            let temp_table_data
            ;[temp_table_data, this.header] = this.reconstruct_table_data([...data], [...header])

            this.table_data = temp_table_data

            console.log('table_data', this.table_data)
        },

        reconstruct_table_data(data, origin_header) {
            const table_data = []
            const time_list = []

            // 整理成以第一個欄位來分類資料
            const first_header = origin_header[0].value

            let parsed_data = {}
            data.forEach((datum) => {
                const key = datum[first_header]
                if (!parsed_data[key]) {
                    parsed_data[key] = {
                        data: {},
                    }
                    origin_header.forEach((col) => {
                        parsed_data[key][col.value] = datum[col.value]
                    })
                }

                const timestamp = dayjs.utc(datum['預報時間'], 'YYYYMMDDHHmm').valueOf()
                parsed_data[key].data[timestamp] = { ...datum }

                if (!time_list.includes(timestamp)) time_list.push(timestamp)
            })

            //排序時間
            time_list.sort()

            //建立含合併時間的header
            const return_header = this.get_header_by_timelist(origin_header, time_list)

            Object.keys(parsed_data).map((key) => {
                time_list.forEach((ts) => {
                    const column = dayjs
                        .utc(ts)
                        .utcOffset(8)
                        .format('YYYYMMDD HH[CST]')
                    const data = parsed_data[key].data[ts]
                    parsed_data[key][column] = this.get_column_html(data, this.unit_column)
                })
                delete parsed_data[key].data
                table_data.push(parsed_data[key])
            })

            return [table_data, return_header]
        },

        get_header_by_timelist(origin_header, time_list) {
            let header = []

            //填入基礎的header
            origin_header.forEach((o) => {
                if (o.value === this.colspan_column) return
                header.push({ ...o })
            })

            //填入需要合併的header
            time_list.forEach((ts, idx) => {
                const order = header.length + 1
                const value = dayjs
                    .utc(ts)
                    .utcOffset(8)
                    .format('YYYYMMDD HH[CST]')
                const date = dayjs
                    .utc(ts)
                    .utcOffset(8)
                    .format('MM[月]DD[日]')
                const timez = dayjs
                    .utc(ts)
                    .utcOffset(8)
                    .format('HH[CST]')
                let option = {
                    order,
                    value,
                    second_text: date,
                    third_text: timez,
                }

                if (idx === 0) option.text = `${this.colspan_column} - ${this.unit_column}`

                header.push(option)
                this.should_show_raw_html_header.push(value)
            })

            return header
        },

        get_column_html(data, column_name) {
            let val = '--'
            if (data && data[column_name] !== undefined) {
                val = data[column_name]
            }

            let html = val
            if (data && data.color) html = `<span style="color:${data.color}">${val}</span>`

            return [
                {
                    center: true,
                    html,
                },
            ]
        },

        switch_unit_column() {
            // 切換單位
            let column_idx = this.unit_column_list.indexOf(this.unit_column)
            column_idx++
            if (column_idx >= this.unit_column_list.length) column_idx = 0

            this.unit_column = this.unit_column_list[column_idx]

            // 重組資料
            let temp_table_data
            ;[temp_table_data, this.header] = this.reconstruct_table_data(
                [...this.immutable_table_data],
                [...this.immutable_table_header],
            )

            this.table_data = temp_table_data
        },
    },
}
</script>

<style>
.datetime_merge_monitor .v-data-table__wrapper {
    height: 65vh;
    overflow-y: scroll;
}
.datetime_merge_monitor th {
    position: sticky;
    height: 2em;
    padding: 0 0.5em !important;
    white-space: nowrap;
    text-align: center;
    z-index: 2;
}
.datetime_merge_monitor tr:first-child th {
    top: 0;
}
.datetime_merge_monitor tr:nth-child(2) th {
    top: 2em;
}
.datetime_merge_monitor tr:nth-child(3) th {
    top: 4em;
}
.datetime_merge_monitor tr:first-child th:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
}
.datetime_merge_monitor td:first-child {
    position: sticky;
    left: 0;
    text-align: center;
    background-color: #fff;
    z-index: 1;
}
.datetime_merge_monitor td {
    text-align: center;
}
</style>

<style scoped>
.switch-btn {
    margin: auto;
    padding: 0 0.5rem;
    height: 24px;
    font-size: small;
    line-height: 24px;
    color: #fff;
    background: #3575c8 !important;
    border-radius: 5px;
}
</style>
